"use client";

import React from "react";

const WhatIsToothExtraction: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          What Is a Tooth Extraction?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          A tooth extraction is the removal of a tooth from its socket in the
          jawbone. It&apos;s one of the most common dental procedures
          performed, and with the right technique and anesthesia, it&apos;s far
          more manageable than most patients expect. Dr. Khaimov numbs the
          treatment area completely before beginning, so the sensation during
          removal is pressure and movement, not pain.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Extraction becomes necessary when a tooth can no longer be restored
          through a filling, crown, or root canal, or when keeping the tooth in
          place would put the surrounding teeth and bone at risk.
        </p>
      </div>
    </section>
  );
};

export default WhatIsToothExtraction;
